import { createBreadcrumbs } from "../forms/breadcrumbs";

if (console.warn) {
    console.warn("pli/breadcrumbs is deprecated and will be removed in pli@8.0. Use import { createBreadCrumbs } from \"pli/forms/breadcrumbs\" instead.");
}

const breadcrumbs = createBreadcrumbs;

/*
    @deprecated
        Will be removed in v8.0. Use import { createBreadcrumbs } from pli/forms/breadcrumbs" instead.
 */
export = breadcrumbs;



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/breadcrumbs/index.ts